import React from 'react';
import { Reveal } from './ui/Reveal';
const attempts = ['Has hecho afirmaciones.', 'Has visualizado.', 'Has leído libros.', 'Has tomado cursos.', 'Has intentado cambiar tus pensamientos.'];
const maybes = ['Tal vez dudas demasiado de ti.', 'Tal vez sabes lo que quieres, pero te cuesta avanzar.', 'Tal vez estás cansada de ser fuerte para todos.', 'Tal vez tu vida por fuera parece estar bien, pero por dentro sabes que quieres algo más.', 'Tal vez llevas mucho tiempo buscando respuestas fuera de ti.'];
export function IdentificationSection() {
  return <section className="bg-ivory px-6 py-20 sm:py-28" data-id="element-136" data-mp="1u72jur8glz0v">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="1u7kn47tjhdia">
        <Reveal data-id="element-138" data-mp="1y84ip6ygs92b">
          <h2 className="text-center font-serif text-[2rem] font-light leading-tight text-ink sm:text-[2.6rem]" data-id="element-139" data-mp="1y8o4iyr8jhlm">
            Has trabajado en ti… pero todavía sientes que{' '}
            <em className="not-italic text-gold-dark" data-id="element-140" data-mp="3u3leqikbu4c">
              algo no termina de cambiar.
            </em>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-141" data-mp="5biltkmx6v3g">
          <ul className="mx-auto mt-11 max-w-lg space-y-3 text-center" data-id="element-142" data-mp="5ctoti8jjyti">
            {attempts.map(line => <li key={line} className="font-serif text-xl italic text-ink-soft sm:text-2xl" data-id="element-143" data-mp="3rqbieiqp7d52">
                {line}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.15} data-id="element-144" data-mp="o9uyhgd1in3s">
          <p className="mt-11 text-center font-serif text-2xl leading-snug text-ink sm:text-3xl" data-id="element-145" data-mp="o93428v6ivf3">
            Y aun así…
            <br data-id="element-146" data-mp="j8fbhiray6ir" />
            <span className="text-gold-dark" data-id="element-147" data-mp="ebf67a2a17sp">
              sigues sintiendo que algo dentro de ti te frena.
            </span>
          </p>
        </Reveal>

        <Reveal delay={0.2} data-id="element-148" data-mp="9bsskzijdpjd">
          <ul className="mt-14 space-y-6 border-t border-gold/25 pt-14" data-id="element-149" data-mp="9eopqlmk8a6r">
            {maybes.map(line => <li key={line} className="flex items-start gap-4" data-id="element-150" data-mp="2u2jmrt7agjzl">
                <span className="mt-3 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-151" data-mp="2u18gnmqdf05b" />
                <span className="text-[17px] leading-relaxed text-ink-soft sm:text-[19px]" data-id="element-152" data-mp="1q4zebiggj3jo">
                  {line}
                </span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.25} data-id="element-153" data-mp="1h2yhgmp4yjij">
          <p className="mt-14 text-center text-[17px] leading-relaxed text-ink-soft sm:text-[19px]" data-id="element-154" data-mp="1h26lharmmjrq">
            Y quizá ha llegado el momento de hacer algo diferente:{' '}
            <span className="font-medium text-ink" data-id="element-155" data-mp="176ve5dijseu0">
              detenerte, escucharte y descubrir qué está ocurriendo realmente
              dentro de ti.
            </span>
          </p>
        </Reveal>

        <Reveal delay={0.3} data-id="element-156" data-mp="yebfwe664c9p">
          <figure className="mt-16 rounded-[1.5rem] border border-gold/30 bg-cream px-7 py-11 text-center sm:px-12 sm:py-14" data-id="element-157" data-mp="ybfhypublnl9">
            <div className="rule-gold mb-8" aria-hidden="true" data-id="element-158" data-mp="of2lxlbayxnc">
              <span className="text-xs text-gold" data-id="element-159" data-mp="ohgglt22m7ud">✦</span>
            </div>
            <blockquote className="font-serif text-[1.7rem] font-light leading-snug text-ink sm:text-[2.1rem]" data-id="element-160" data-mp="4ubvydhapivg">
              No necesitas convertirte en otra mujer.{' '}
              <em className="not-italic text-gold-dark" data-id="element-161" data-mp="es9kz36zbjp4">
                Necesitas volver a conectar con quien eres.
              </em>
            </blockquote>
          </figure>
        </Reveal>
      </div>
    </section>;
}